import * as THREE from 'three';
import { GUI } from 'dat.gui';
export default {
  getScene(): THREE.Scene {
    const scene = new THREE.Scene();
    scene.background = new THREE.Color(0xffffff);
    scene.add(new THREE.AmbientLight(0xffffff, 0.2));
    return scene;
  },
  getOrthographicCamera(
    fov: number,
    perspective: number,
    width: number,
    height: number,
  ): THREE.OrthographicCamera {
    const halfFovV = THREE.MathUtils.DEG2RAD * fov * 0.5;
    const halfFovH = Math.atan((width / height) * Math.tan(halfFovV));
    const halfW = perspective * Math.tan(halfFovH);
    const halfH = perspective * Math.tan(halfFovV);
    const near = 0.01;
    const far = 20000;
    const dirLight = new THREE.DirectionalLight(0xffffff, 0.9);

    dirLight.shadow.camera.near = 0.01;
    dirLight.castShadow = true;

    const camera = new THREE.OrthographicCamera(-halfW, halfW, halfH, -halfH, near, far);
    camera.add(dirLight);
    camera.position.set(0, 0, perspective);
    return camera;
  },
  getPerspectiveCamera(fov: number, ratio: number): THREE.PerspectiveCamera {
    const camera = new THREE.PerspectiveCamera(fov, ratio, 0.1, 20000);
    const dirLight = new THREE.DirectionalLight(0xffffff, 1);

    dirLight.shadow.camera.near = 0.01;
    dirLight.castShadow = true;
    camera.add(dirLight);
    return camera;
  },

  getStatsGroup(dl: THREE.DirectionalLight): THREE.Group {
    const mainGroup = new THREE.Group();
    const gui = new GUI();

    mainGroup.position.y = 0.5;
    // set up ambient light
    const al = new THREE.AmbientLight(0xffffff, 0.5);
    mainGroup.add(al);
    // set up ambient light gui
    const alFolder = gui.addFolder('ambient light');
    const alSettings = { color: al.color.getHex() };
    alFolder.add(al, 'visible');
    alFolder.add(al, 'intensity', 0, 1, 0.1);
    alFolder.addColor(alSettings, 'color').onChange((value) => al.color.set(value));
    alFolder.open();
    const dlHelper = new THREE.DirectionalLightHelper(dl, 3);
    mainGroup.add(dl);

    // set up directional light gui
    const dlSettings = {
      visible: true,
      color: dl.color.getHex(),
    };
    const dlFolder = gui.addFolder('directional light');
    dlFolder.add(dlSettings, 'visible').onChange((value) => {
      dl.visible = value;
      dlHelper.visible = value;
    });
    dlFolder.add(dl, 'intensity', 0, 1, 0.25);

    dlFolder.add(dl, 'castShadow');
    dlFolder.addColor(dlSettings, 'color').onChange((value) => dl.color.set(value));
    dlFolder.open();

    // set up spot light + helper
    const sl = new THREE.SpotLight(0x00ff00, 1, 18, Math.PI / 8, 0);
    sl.position.set(0, 0, -2);
    const slHelper = new THREE.SpotLightHelper(sl);
    mainGroup.add(sl, slHelper);

    // set up spot light gui
    const slSettings = {
      visible: true,
    };
    const slFolder = gui.addFolder('spot light');
    slFolder.add(slSettings, 'visible').onChange((value) => {
      sl.visible = value;
      slHelper.visible = value;
    });
    slFolder.add(sl, 'distance', 0, 20, 0.5);
    slFolder.add(sl, 'intensity', 0, 4, 0.5);
    slFolder.add(sl, 'angle', Math.PI / 16, Math.PI / 2, Math.PI / 16);
    slFolder.add(sl, 'castShadow');
    slFolder.open();

    const pl = new THREE.PointLight(0xffffff, 1, 8, 2);
    pl.position.set(2, 2, 2);
    const plHelper = new THREE.PointLightHelper(pl, 0.5);
    mainGroup.add(pl, plHelper);

    // set up point light gui
    const plSettings = {
      visible: true,
      color: pl.color.getHex(),
    };
    const plFolder = gui.addFolder('point light');
    plFolder.add(plSettings, 'visible').onChange((value) => {
      pl.visible = value;
      plHelper.visible = value;
    });
    plFolder.add(pl, 'intensity', 0, 2, 0.25);
    plFolder.add(pl.position, 'x', -2, 4, 0.5);
    plFolder.add(pl.position, 'y', -2, 4, 0.5);
    plFolder.add(pl.position, 'z', -2, 4, 0.5);
    plFolder.add(pl, 'castShadow');
    plFolder.addColor(plSettings, 'color').onChange((value) => pl.color.set(value));
    plFolder.open();
    return mainGroup;
  },
};
